export default __webpack_public_path__ + "static/media/banner-04.d443d028.jpg";